import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';
import { PrimaryFunction } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PrimaryFunctionsService extends BaseService<PrimaryFunction> {

  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  protected getResourceUrl(): string {
    return this.baseUrl + 'primary-functions/';
  }
}
